var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-wrapper" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "worker_data ibox-content",
        staticStyle: { "padding-left": "0" }
      },
      [
        _c("div", { staticClass: "nav_cha" }, [_vm._v("职工信息")]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "formInline",
                staticClass: "demo-form-inline",
                attrs: {
                  inline: true,
                  model: _vm.formInline,
                  rules: _vm.rules,
                  "label-width": "94px",
                  "label-position": "right"
                }
              },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { label: "幼儿园：", prop: "gardenId" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: { filterable: "", placeholder: "请选择幼儿园" },
                        model: {
                          value: _vm.formInline.gardenId,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "gardenId", $$v)
                          },
                          expression: "formInline.gardenId"
                        }
                      },
                      _vm._l(_vm.selectGarden, function(item) {
                        return _c("el-option", {
                          key: item.orgID,
                          attrs: { label: item.fullName, value: item.orgID }
                        })
                      })
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { label: "姓名：", prop: "teacherName" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入姓名" },
                      model: {
                        value: _vm.formInline.teacherName,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "teacherName", $$v)
                        },
                        expression: "formInline.teacherName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { label: "性别：", prop: "teacherSex" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: { placeholder: "请选择性别" },
                        model: {
                          value: _vm.formInline.teacherSex,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "teacherSex", $$v)
                          },
                          expression: "formInline.teacherSex"
                        }
                      },
                      [
                        _c("el-option", {
                          key: "男",
                          attrs: { label: "男", value: "1" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          key: "女",
                          attrs: { label: "女", value: "2" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { label: "生日：", prop: "teacherBirthday" }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        type: "date",
                        placeholder: "选择日期"
                      },
                      model: {
                        value: _vm.formInline.teacherBirthday,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "teacherBirthday", $$v)
                        },
                        expression: "formInline.teacherBirthday"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { label: "身份证号码：", prop: "teacherIDCard" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入身份证号码" },
                      model: {
                        value: _vm.formInline.teacherIDCard,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "teacherIDCard", $$v)
                        },
                        expression: "formInline.teacherIDCard"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { label: "婚否：" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.formInline.teacherMarry,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "teacherMarry", $$v)
                          },
                          expression: "formInline.teacherMarry"
                        }
                      },
                      [
                        _c("el-option", {
                          key: "未婚",
                          attrs: { label: "未婚", value: "未婚" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          key: "已婚",
                          attrs: { label: "已婚", value: "已婚" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { label: "岗位：" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入岗位名称" },
                      model: {
                        value: _vm.formInline.teacherPosition,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "teacherPosition", $$v)
                        },
                        expression: "formInline.teacherPosition"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { label: "民族：" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.formInline.teacherNational,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "teacherNational", $$v)
                          },
                          expression: "formInline.teacherNational"
                        }
                      },
                      _vm._l(_vm.nationList, function(item) {
                        return _c("el-option", {
                          key: item.code,
                          attrs: { label: item.name, value: item.code }
                        })
                      })
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { label: "手机号码：", prop: "teacherTelPhone" }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入手机号" },
                      model: {
                        value: _vm.formInline.teacherTelPhone,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "teacherTelPhone", $$v)
                        },
                        expression: "formInline.teacherTelPhone"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "nav_cha" }, [_vm._v("体检信息")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { label: "体检日期：", prop: "checkDate" }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        type: "date",
                        placeholder: "选择体检日期"
                      },
                      model: {
                        value: _vm.formInline.checkDate,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "checkDate", $$v)
                        },
                        expression: "formInline.checkDate"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { label: "体检单位：" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入体检单位" },
                      model: {
                        value: _vm.formInline.hospital,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "hospital", $$v)
                        },
                        expression: "formInline.hospital"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { label: "主治医师：" }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入主治医师" },
                      model: {
                        value: _vm.formInline.doctor,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "doctor", $$v)
                        },
                        expression: "formInline.doctor"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.CategoryList, function(item) {
                  return _c(
                    "div",
                    { key: item.id },
                    [
                      _c("div", { staticClass: "nav_cha" }, [
                        _vm._v(_vm._s(item.categoryName))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.detailList, function(val, num) {
                        return val.categoryId == item.id
                          ? _c(
                              "el-form-item",
                              {
                                key: val.id,
                                staticStyle: { width: "400px" },
                                attrs: { label: val.itemName + "：" }
                              },
                              [
                                val.unit
                                  ? [
                                      val.valueType == 2 || val.valueType == 1
                                        ? _c("el-input", {
                                            staticStyle: { width: "150px" },
                                            model: {
                                              value: val.defaultValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  val,
                                                  "defaultValue",
                                                  $$v
                                                )
                                              },
                                              expression: "val.defaultValue"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(val.unit))])
                                    ]
                                  : [
                                      val.valueType == 3
                                        ? _c(
                                            "el-select",
                                            {
                                              ref: val.id,
                                              refInFor: true,
                                              staticStyle: { width: "150px" },
                                              on: {
                                                change: function($event) {
                                                  _vm.customizeInput(
                                                    $event,
                                                    val,
                                                    val.id,
                                                    num
                                                  )
                                                }
                                              },
                                              model: {
                                                value: val.defaultValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    val,
                                                    "defaultValue",
                                                    $$v
                                                  )
                                                },
                                                expression: "val.defaultValue"
                                              }
                                            },
                                            [
                                              _vm._l(
                                                val.valueOptions.split(","),
                                                function(el) {
                                                  return [
                                                    _c("el-option", {
                                                      key: el,
                                                      attrs: {
                                                        label: el,
                                                        value: el
                                                      }
                                                    })
                                                  ]
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      val.valueType == 2 || val.valueType == 1
                                        ? _c("el-input", {
                                            staticStyle: { width: "150px" },
                                            model: {
                                              value: val.defaultValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  val,
                                                  "defaultValue",
                                                  $$v
                                                )
                                              },
                                              expression: "val.defaultValue"
                                            }
                                          })
                                        : _vm._e()
                                    ]
                              ],
                              2
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "nav_cha" }, [
                  _vm._v("检查结果（医院评定）")
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { staticClass: "evaluate" },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea", rows: 5 },
                      model: {
                        value: _vm.formInline.checkResult,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "checkResult", $$v)
                        },
                        expression: "formInline.checkResult"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "nav_cha" }, [_vm._v("医生意见")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { staticClass: "evaluate" },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea", rows: 5 },
                      model: {
                        value: _vm.formInline.doctorSuggestion,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "doctorSuggestion", $$v)
                        },
                        expression: "formInline.doctorSuggestion"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "hold",
                    staticStyle: { "margin-top": "20px" }
                  },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            attrs: { type: "primary", size: "large" },
                            on: {
                              click: function($event) {
                                _vm.submit(_vm.formInline)
                              }
                            }
                          },
                          [_vm._v("保存")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [_vm._v("职工体检添加")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c0aa08c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c0aa08c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/physical/teacherPhyAdd.vue
// module id = null
// module chunks = 